module.exports = __webpack_public_path__ + "static/media/arrow-off-nordeste.9d93fb62.png";